type EuComplianceSourceType = 'portCall' | 'seaPassage';

export type EuComplianceRow = {
	type: EuComplianceSourceType;
	sourceId: number;
	sourceIds?: number[];
	apply?: boolean;
};

export const getEuEtsApply = (
	rows: EuComplianceRow[] | undefined,
	type: EuComplianceSourceType,
	sourceId: number,
) => {
	const row = rows?.find((item) => (
		item.type === type &&
		(item.sourceIds ?? [item.sourceId]).includes(sourceId)
	));

	return row?.apply ?? true;
};

export const getFuelEuApply = (
	rows: EuComplianceRow[] | undefined,
	type: EuComplianceSourceType,
	sourceId: number,
) => {
	const matchingRows = rows?.filter((item) => (
		item.type === type &&
		(item.sourceIds ?? [item.sourceId]).includes(sourceId)
	)) ?? [];

	if (matchingRows.length === 0) {
		return true;
	}

	return matchingRows.some((row) => row.apply !== false);
};

export const updateEuComplianceRowsApply = (
	rows: EuComplianceRow[],
	type: EuComplianceSourceType,
	sourceId: number,
	apply: boolean,
) => rows.map((row) => (
	row.type === type &&
	(row.sourceIds ?? [row.sourceId]).includes(sourceId) ?
		{ ...row, apply } :
		row
));